/**
 * Auth-related shapes — current-user response, mock-auth helpers for local dev.
 */
import { z } from 'zod';
import { UserPublicSchema } from './users.js';
import { RoleSchema } from './enums.js';
/** In-app appearance preference. 'system' follows the OS light/dark setting. */
export const ThemePreferenceSchema = z.enum(['light', 'dark', 'system']);
/**
 * Shape returned by GET /me.
 *
 * `id` is loosened from strict UUID to plain string here because in local
 * dev with MOCK_AUTH=true we don't have a persisted users row yet — the
 * mock identity uses the Entra `oid` value as its id. Once users are
 * persisted (M2), real users will have UUIDs and the value will still
 * satisfy this looser schema.
 */
export const CurrentUserSchema = UserPublicSchema.omit({ id: true }).extend({
    id: z.string().min(1),
    email: z.string().email(),
    role: RoleSchema,
    entra_oid: z.string(),
    /** Set when this user is also a crew member (incl. a player-coach supervisor),
     *  so the client can surface the crew self-views (Today / My week). */
    crew_member_id: z.string().nullable(),
    /** Saved appearance choice; the client applies it on load (and across devices). */
    theme_preference: ThemePreferenceSchema.default('system'),
});
/** PATCH /me/theme body. */
export const ThemePreferenceUpdateSchema = z.object({
    theme_preference: ThemePreferenceSchema,
});
//# sourceMappingURL=auth.js.map